import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => import("layouts/LayoutsIndex.vue"),
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/dashboard/Dashboard.vue"
          ),
      },
      {
        path: "/reexaminers",
        name: "ReExaminers",
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/dashboard/ReExaminerList.vue"
          ),
      },
      {
        path: "/users",
        name: "UserList",
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/user/UserList.vue"
          ),
      },
      {
        path: "/users/:userUUID",
        name: "UserProfile",
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/user/UserProfile.vue"
          ),
        props: true,
      },
      {
        path: "/license",
        name: "LicenseList",
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/license/LicenseList.vue"
          ),
      },
      {
        path: "/companies",
        name: "CompanyList",
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/company/CompanyList.vue"
          ),
      },
      {
        path: "/admins",
        name: "AdministratorList",
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/administrator/AdministratorList.vue"
          ),
      },
      {
        path: "/notifications",
        name: "NotificationList",
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/notification/NotificationList.vue"
          ),
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    component: () => import("pages/ErrorNotFound.vue"),
  },
];

export default routes;
